import { graphql } from '../../gql';

export const SENTIMENT_GET_OVERTIME_DATA_V2 = graphql(`
  query GetSentimentData($filters: SentimentV2Filters, $dim1: Dimension1) {
    sentiment(filters: $filters, dim1: $dim1) {
      metadata {
        id
        shortName
        longName
        metadata_type
      }
      result {
        scores {
          overall {
            count
            value
            month_id
            weight
          }
          business_outlook {
            count
            value
            month_id
            weight
          }
          career_growth {
            count
            value
            month_id
            weight
          }
          compensation {
            count
            value
            month_id
            weight
          }
          benefits {
            count
            value
            month_id
            weight
          }
          healthcare {
            count
            value
            month_id
            weight
          }
          retirement_pension {
            count
            value
            month_id
            weight
          }
          childcare {
            count
            value
            month_id
            weight
          }
          education_assistance {
            count
            value
            month_id
            weight
          }
          wellness_programs {
            count
            value
            month_id
            weight
          }
          work_life_balance {
            count
            value
            month_id
            weight
          }
          diversity_and_inclusion {
            count
            value
            month_id
            weight
          }
          leadership {
            count
            value
            month_id
            weight
          }
          culture {
            count
            value
            month_id
            weight
          }
          remote_work {
            count
            value
            month_id
            weight
          }
          onboarding {
            count
            value
            month_id
            weight
          }
          mentorship {
            count
            value
            month_id
            weight
          }
          technology {
            count
            value
            month_id
            weight
          }
          promotion_opportunities {
            count
            value
            month_id
            weight
          }
          paid_time_off {
            count
            value
            month_id
            weight
          }
          transparency {
            count
            value
            month_id
            weight
          }
          efficiency_and_bureaucracy {
            count
            value
            month_id
            weight
          }
          product_and_service_quality {
            count
            value
            month_id
            weight
          }
          prestige {
            count
            value
            month_id
            weight
          }
          coworkers {
            count
            value
            month_id
            weight
          }
          mission_and_vision {
            count
            value
            month_id
            weight
          }
          workplace_facilities {
            count
            value
            month_id
            weight
          }
          training {
            count
            value
            month_id
            weight
          }
          clients_and_customers {
            count
            value
            month_id
            weight
          }
          company_growth {
            count
            value
            month_id
            weight
          }
          schedule_flexibility {
            count
            value
            month_id
            weight
          }
          job_security {
            count
            value
            month_id
            weight
          }
          overtime {
            count
            value
            month_id
            weight
          }
          family_support {
            count
            value
            month_id
            weight
          }
          commission {
            count
            value
            month_id
            weight
          }
          independence {
            count
            value
            month_id
            weight
          }
          commute {
            count
            value
            month_id
            weight
          }
          safety {
            count
            value
            month_id
            weight
          }
          internal_communication {
            count
            value
            month_id
            weight
          }
          office_politics {
            count
            value
            month_id
            weight
          }
          harassment {
            count
            value
            month_id
            weight
          }
          honesty {
            count
            value
            month_id
            weight
          }
          ethics {
            count
            value
            month_id
            weight
          }
          commitment {
            count
            value
            month_id
            weight
          }
          compliance {
            count
            value
            month_id
            weight
          }
          integrity {
            count
            value
            month_id
            weight
          }
        }
      }
      months_refs {
        id
        shortName
        longName
      }
    }
  }
`);

/**
 * Lightweight sentiment query for overview pages.
 * Returns only value and weight per metric (no count/month_id timeseries),
 * plus months_refs for date lookup.
 */
export const SENTIMENT_SNAPSHOT = graphql(`
  query GetSentimentSnapshot($filters: SentimentV2Filters, $dim1: Dimension1) {
    sentiment(filters: $filters, dim1: $dim1) {
      metadata {
        id
        shortName
        longName
        metadata_type
      }
      result {
        scores {
          overall {
            value
            weight
          }
          business_outlook {
            value
            weight
          }
          career_growth {
            value
            weight
          }
          compensation {
            value
            weight
          }
          benefits {
            value
            weight
          }
          healthcare {
            value
            weight
          }
          retirement_pension {
            value
            weight
          }
          childcare {
            value
            weight
          }
          education_assistance {
            value
            weight
          }
          wellness_programs {
            value
            weight
          }
          work_life_balance {
            value
            weight
          }
          diversity_and_inclusion {
            value
            weight
          }
          leadership {
            value
            weight
          }
          culture {
            value
            weight
          }
          remote_work {
            value
            weight
          }
          onboarding {
            value
            weight
          }
          mentorship {
            value
            weight
          }
          technology {
            value
            weight
          }
          promotion_opportunities {
            value
            weight
          }
          paid_time_off {
            value
            weight
          }
          transparency {
            value
            weight
          }
          efficiency_and_bureaucracy {
            value
            weight
          }
          product_and_service_quality {
            value
            weight
          }
          prestige {
            value
            weight
          }
          coworkers {
            value
            weight
          }
          mission_and_vision {
            value
            weight
          }
          workplace_facilities {
            value
            weight
          }
          training {
            value
            weight
          }
          clients_and_customers {
            value
            weight
          }
          company_growth {
            value
            weight
          }
          schedule_flexibility {
            value
            weight
          }
          job_security {
            value
            weight
          }
          overtime {
            value
            weight
          }
          family_support {
            value
            weight
          }
          commission {
            value
            weight
          }
          independence {
            value
            weight
          }
          commute {
            value
            weight
          }
          safety {
            value
            weight
          }
          internal_communication {
            value
            weight
          }
          office_politics {
            value
            weight
          }
          harassment {
            value
            weight
          }
          honesty {
            value
            weight
          }
          ethics {
            value
            weight
          }
          commitment {
            value
            weight
          }
          compliance {
            value
            weight
          }
          integrity {
            value
            weight
          }
        }
      }
      months_refs {
        id
        shortName
        longName
      }
    }
  }
`);

export const SENTIMENT_GET_MAP_DATA = graphql(`
  query GetSentimentMapData($filters: SentimentV2Filters, $dim1: Dimension1) {
    sentiment(filters: $filters, dim1: $dim1) {
      metadata {
        id
        shortName
        longName
        metadata_type
      }
      result {
        scores {
          overall {
            value
          }
          business_outlook {
            value
          }
          career_growth {
            value
          }
          compensation {
            value
          }
          benefits {
            value
          }
          healthcare {
            value
          }
          retirement_pension {
            value
          }
          childcare {
            value
          }
          education_assistance {
            value
          }
          wellness_programs {
            value
          }
          work_life_balance {
            value
          }
          diversity_and_inclusion {
            value
          }
          leadership {
            value
          }
          culture {
            value
          }
          remote_work {
            value
          }
          onboarding {
            value
          }
          mentorship {
            value
          }
          technology {
            value
          }
          promotion_opportunities {
            value
          }
          paid_time_off {
            value
          }
          transparency {
            value
          }
          efficiency_and_bureaucracy {
            value
          }
          product_and_service_quality {
            value
          }
          prestige {
            value
          }
          coworkers {
            value
          }
          mission_and_vision {
            value
          }
          workplace_facilities {
            value
          }
          training {
            value
          }
          clients_and_customers {
            value
          }
          company_growth {
            value
          }
          schedule_flexibility {
            value
          }
          job_security {
            value
          }
          overtime {
            value
          }
          family_support {
            value
          }
          commission {
            value
          }
          independence {
            value
          }
          commute {
            value
          }
          safety {
            value
          }
          internal_communication {
            value
          }
          office_politics {
            value
          }
          harassment {
            value
          }
          honesty {
            value
          }
          ethics {
            value
          }
          commitment {
            value
          }
          compliance {
            value
          }
          integrity {
            value
          }
        }
      }
    }
  }
`);
